import React from "react";

export const AvatarChooserBackground = () => {
    return <g>
        <rect className="st7" height="860.7" width="1520" x="-760" y="-430.3"/>
        <path className="st8"
              d="M-745.9,424.3l1504.5-15l-21.4-826.5l-1495.7-12.9L-745.9,424.3z M-770-436H770v872H-770V-436z"/>
    </g>
};
